(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.CompaniesService = (function(superClass) {
    extend(CompaniesService, superClass);

    function CompaniesService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.saveCompanyLineups = bind(this.saveCompanyLineups, this);
      this.saveCompanyPagesAndReports = bind(this.saveCompanyPagesAndReports, this);
      this.createNewCompany = bind(this.createNewCompany, this);
      this.saveSeedCompany = bind(this.saveSeedCompany, this);
      this.getAllSeedCompanies = bind(this.getAllSeedCompanies, this);
      this.getAllCrops = bind(this.getAllCrops, this);
      this.getLineupsForCompany = bind(this.getLineupsForCompany, this);
      this.getReportsForCompany = bind(this.getReportsForCompany, this);
      this.getPagesForCompany = bind(this.getPagesForCompany, this);
      this.getCompaniesData = bind(this.getCompaniesData, this);
      void 0;
    }

    CompaniesService.prototype.getCompaniesData = function() {
      return this.http.post('backend/admin/new-tools/companies/list-companies');
    };

    CompaniesService.prototype.getPagesForCompany = function(companyId) {
      return this.http.post('backend/admin/new-tools/companies/list-companies-pages', {
        id: companyId
      });
    };

    CompaniesService.prototype.getReportsForCompany = function(companyId) {
      return this.http.post('backend/admin/new-tools/companies/list-companies-reports', {
        id: companyId
      });
    };

    CompaniesService.prototype.getLineupsForCompany = function(companyId) {
      return this.http.post('backend/admin/new-tools/companies/list-companies-lineups', {
        id: companyId
      });
    };

    CompaniesService.prototype.getAllCrops = function() {
      return this.http.post('backend/admin/new-tools/companies/list-all-crops');
    };

    CompaniesService.prototype.getAllSeedCompanies = function() {
      return this.http.post('backend/admin/new-tools/companies/list-all-seed-companies');
    };

    CompaniesService.prototype.saveSeedCompany = function(pretend, name, country) {
      return this.http.post('backend/admin/new-tools/companies/save-seed-company', {
        pretend: pretend,
        name: name,
        country: country
      });
    };

    CompaniesService.prototype.createNewCompany = function(username, company, password, phone, email, address1, address2, city, state, zipcode) {
      return this.http.post('backend/admin/new-tools/companies/create-new-company', {
        username: username,
        company: company,
        password: password,
        phone: phone,
        email: email,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        zipcode: zipcode
      });
    };

    CompaniesService.prototype.saveCompanyPagesAndReports = function(companyId, pages, reports) {
      return this.http.post('backend/admin/new-tools/companies/save-company-pages-and-reports', {
        id: companyId,
        pages: pages,
        reports: reports
      });
    };

    CompaniesService.prototype.saveCompanyLineups = function(companyId, lineups) {
      return this.http.post('backend/admin/new-tools/companies/save-company-lineups', {
        id: companyId,
        lineups: lineups
      });
    };

    return CompaniesService;

  })(Service);

}).call(this);
